<template>
    <el-drawer
        title="筛选"
        :visible.sync="drawer"
        :direction="direction"
        :before-close="handleClose">
        <div class="slot_box">
            <ul class="ul_box">
                <li class="li_box" v-for="(val,index) in rawer_list" :key="index">
                    <p>{{val.label}}</p>
                    <el-select clearable v-if="val[[val.prop]+'_list']" v-model="val[val.prop]" :placeholder="val.placeholder">
                        <el-option
                        v-for="item in val[[val.prop]+'_list']"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                    <el-input v-else v-model="val[val.prop]" :placeholder="val.placeholder"></el-input>
                </li>
            </ul>
            <div>
                <el-button @click="chongZhi">重置</el-button>
                <el-button type="primary" @click="screen">筛选</el-button>
            </div>
        </div>
    </el-drawer>
</template>

<script>
    export default {
        props:{
            drawer:Boolean,
            direction:String,
            rawer_list:Array
        },
        data() {
            return {
                screen_data:{} //所有筛选的条件字段
            };
        },
        methods: {
            //校验
            // check(){
            //     let val = this.rawer_list
            //     for(let i=0;i<val.length;i++){
            //         if(val[i][val[i].prop]==''){
            //             this.$message.error(val[i].placeholder);
            //             return false
            //         }
            //     }
            //     console.log('校验通过')
            //     return true
            // },
            //刷选
            screen(){
                this.screen_data = {} //清空所有筛选的条件字段
                //遍历全部输入框和下拉选择菜单
                this.rawer_list.forEach(val => {
                    //输入框有值的话就取出用户输入的筛选值放进screen_data
                    if(val[val.prop]){
                        this.screen_data[val.prop] = val[val.prop]
                    }
                });
                this.$emit('screen',this.screen_data)
            },
            handleClose(){
                this.$emit('handleClose_drawer',false)
            },
            chongZhi() {
                this.screen_data = {}
                this.rawer_list.forEach(val => {
                    //输入框有值的话就取出用户输入的筛选值放进screen_data
                    if(val[val.prop]){
                        val[val.prop] = ''
                    }
                });
                this.$emit('reset')
            }
        }
    };
</script>

<style lang="scss">
.slot_box{
    width: 100%;
    padding: 15px;
    .ul_box{
        .li_box{
            margin: 10px 0;
            input{
                margin-top: 5px;
            }
        }
    }
}
</style>